<template>
  <div class="payment-error-container">
    <div class="error-card">
      <div class="logo-section">
        <img src="@/assets/images/logo/logo.png" alt="Logo" class="logo" />
      </div>

      <div class="error-icon">
        <feather-icon icon="XCircleIcon" size="64" class="text-danger" />
      </div>

      <h1 class="error-title">{{ $t('Payment Failed!') }}</h1>

      <div class="error-message">
        <p>{{ $t('Your payment could not be processed. Please try again.') }}</p>
        <p v-if="errorMessage" class="error-details">{{ errorMessage }}</p>
      </div>

      <div class="action-buttons">
        <b-button variant="outline-primary" size="lg" @click="goToPayments">
          <div class="d-flex align-items-center">
            <feather-icon icon="ListIcon" size="16" class="mr-2" />
            <span>{{ $t('View All Payments') }}</span>
          </div>
        </b-button>

        <b-button variant="outline-secondary" size="lg" @click="goToDashboard">
          <div class="d-flex align-items-center">
            <feather-icon icon="HomeIcon" size="16" class="mr-2" />
            <span>{{ $t('Go to Dashboard') }}</span>
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  name: 'PaymentError',
  components: {
    BButton
  },
  data() {
    return {
      orderId: this.$route.query.orderId || this.$route.params.orderId,
      amount: this.$route.query.amount || '0.00',
      currency: this.$route.query.currency || 'USD',
      errorMessage: this.$route.query.error || this.$route.params.error || ''
    };
  },
  methods: {
    goToPayments() {
      this.$router.push({ name: 'payments' });
    },

    goToDashboard() {
      this.$router.push({ name: 'dashboard' });
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>

<style scoped lang="scss">
.payment-error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  padding: 2rem;
}

.error-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 500px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 2rem;
    margin: 1rem;
  }
}

.logo-section {
  margin-bottom: 2rem;

  .logo {
    max-height: 60px;
    width: auto;
    object-fit: contain;
  }
}

.error-icon {
  margin-bottom: 2rem;

  .feather-icon {
    color: #dc3545;
  }
}

.error-title {
  color: #2c3e50;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
}

.error-message {
  margin-bottom: 2rem;

  p {
    color: #6c757d;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .error-details {
    background: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 8px;
    padding: 1rem;
    color: #721c24;
    font-size: 0.9rem;
    margin-top: 1rem;
  }
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;

    .btn {
      width: 100%;
    }
  }
}

.btn {
  border-radius: 10px;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
}

.badge {
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
}
</style>
